import { z } from 'zod'

/**
 * Salesforce Webhook Payload Schema
 * Represents webhook events from Salesforce for Lead or Opportunity objects
 */
export const salesforcePayloadSchema = z.object({
  object_name: z.enum(['Lead', 'Opportunity', 'Account', 'Event']),
  record_id: z.string(),
  change_type: z.enum(['CREATE', 'UPDATE', 'DELETE']),
  timestamp: z.string(),
  changed_fields: z.array(z.string()).default([]),
  full_payload: z.string(),
})

/**
 * Schema for storing raw Salesforce webhook payloads
 * We store the entire payload as-is to allow for reprocessing and debugging
 */
export const salesforceEventSchema = z.object({
  id: z.string(),
  event: salesforcePayloadSchema,
  record_id: z.string(),
  received_at: z.coerce.date(),
})

export type ChangeType = keyof typeof salesforcePayloadSchema.shape.change_type.enum
export type ObjectName = keyof typeof salesforcePayloadSchema.shape.object_name.enum
export type SalesforceEvent = z.infer<typeof salesforceEventSchema>
export type CreateSalesforceEvent = z.infer<typeof salesforcePayloadSchema>
